export const AccountEndpoints = {
  save: '/account/save',
  changePassword: '/account/change-password',
  changeEmail: '/account/change-email',
  details: '/account/details',
  dashboardPreferences: '/account/dashboard-preferences',
  dashboardPreferencesSave: '/account/dashboard-preferences/save',
  dashboardPreferencesImport: '/account/dashboard-preferences/import',
  notificationsPreferencesAvailableList: '/account/notification-preferences/available/list',
  notificationsPreferencesDisabledList: '/account/notification-preferences/disabled/list',
  notificationsPreferencesDisabledSave: '/account/notification-preferences/disabled/save',
  loginSessionList: '/account/sessions',
  loginSessionExport: '/account/sessions/export',
  notificationList: '/account/notifications',
  linkGoogleAccount: '/account/google-account',
  unlinkGoogleAccount: '/account/google-account',
  permissionsAvailableList: '/account/permissions/available/list',
} as const;
